export const EVENT_NAME = "login-event";
export const MSG = "postSignin";
export const SIGNED_IN_FLAG = "postSignInReload";
export const DATASTORE_CHANNEL = 'datastore';
export const READY_EVENT = 'ready';